import { CardPaymentMethodDetails, PaymentCardFormat, PaymentCardState } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedEnum } from '@mews/framework';
import { Stack, Tag, Typography } from '@optimus-web/core';
import PaymentCardIcon from '../../../../../../../components/commander-ui/PaymentCardIcon';
import { PaymentDetailsSidebarGrid } from '../PaymentDetailsSidebarGrid';
import { PaymentDetailsSidebarRow, PaymentDetailsSidebarRowTypography } from '../PaymentDetailsSidebarRow';
import { paymentCardStateTagVariantMap } from '../../utils';

const creditCardStatusRow = (status: PaymentCardState) => (
    <PaymentDetailsSidebarRow labelTextKey={TextKey.Status}>
        <Tag variant={paymentCardStateTagVariantMap[status]}>
            <LocalizedEnum prefix="PaymentCardState" value={status} />
        </Tag>
    </PaymentDetailsSidebarRow>
);

const formatRow = (format: PaymentCardFormat) => (
    <PaymentDetailsSidebarRow labelTextKey={TextKey.Type}>
        <Typography textStyle="bodyMedium" as="div">
            <LocalizedEnum prefix="PaymentCardFormat" value={format} />
        </Typography>
    </PaymentDetailsSidebarRow>
);

export const CardPaymentMethod = ({ cardPaymentMethod }: { cardPaymentMethod: CardPaymentMethodDetails }) => {
    return (
        <PaymentDetailsSidebarGrid>
            <PaymentDetailsSidebarRow labelTextKey={TextKey.Method}>
                <Stack itemAlignment="center" spacing="50">
                    <PaymentCardIcon type={cardPaymentMethod.type} width={24} />
                    <Typography textStyle="bodyMedium" as="div">
                        {cardPaymentMethod.lastDigits ?? ''}
                    </Typography>
                </Stack>
            </PaymentDetailsSidebarRow>
            <PaymentDetailsSidebarRowTypography labelTextKey={TextKey.Owner} value={cardPaymentMethod.holderName} />
            {creditCardStatusRow(cardPaymentMethod.state)}
            {formatRow(cardPaymentMethod.format)}
        </PaymentDetailsSidebarGrid>
    );
};
